import { FormFieldTypes } from "../../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
    pdteffectiveDate: null,
    pdtendDate: null,
  };

  export const AddContractScopesFormConfig = {
    name: "AddContractScopes",
    initialState: initState,
    section: [
      {
        sectionId: "AddContractScopes",
        title: "Add Contract Scopes ",
        row: {},
        style: {
          sectionStyle: "col-lg-12 col-md-12",
        },
        wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component

            fields: [
              {
                id: "pdteffectiveDate",
                label: "Effective Date:",
                Field_Name: "Effective Date",
                fieldType: FormFieldTypes.DATEPICKER,
                dataField: "pdteffectiveDate",
                fieldSetting: {
                  placeholder: "Enter Effective Date",
                },
                validation: [{ type: "require" }],
                style: {
                  containerCss: "col-lg-12 col-md-4 col-4 mb-2 ",
                },
              },
              {
                id: "pdtendDate",
                label: "End Date:",
                Field_Name: "End Date",
                fieldType: FormFieldTypes.DATEPICKER,
                dataField: "pdtendDate",
                fieldSetting: {
                  placeholder: "Enter End Date",
                },
                validation: [{ type: "require" }],
                style: {
                  containerCss: "col-lg-12 col-md-4 col-4 mb-2 ",
                },
              },
            ],
          },
        ],
  };